<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片主体(表格) -->
        <md-card-content>
          <!-- 卡片主体(表单) -->
          <div class="md-layout card-form" style="max-width: 800px;">
            <!-- APP ID -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("app_id")}}</label>
                <md-input v-model="searchForm.app_key" />
              </md-field>
            </div>
            <!-- 关联数据 -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("link_id")}}</label>
                <md-input v-model="searchForm.link_id" />
              </md-field>
            </div>
            <!-- 平台类型 -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("push_type")}}</label>
                <md-select v-model="searchForm.type">
                  <md-option value="sms">{{$I18n('sms')}}</md-option>
                  <md-option value="email">{{$I18n('email')}}</md-option>
                  <md-option value="msg">{{$I18n('msg')}}</md-option>
                  <md-option value="voice">{{$I18n('simple_phone')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 状态 -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("state")}}</label>
                <md-select v-model="searchForm.state">
                  <md-option value="0">{{$I18n('all')}}</md-option>
                  <md-option value="1">{{$I18n('pending')}}</md-option>
                  <md-option value="2">{{$I18n('succ_num')}}</md-option>
                  <md-option value="3">{{$I18n('fail_num')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片主体(表格) -->
        <md-card-content>
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <!-- <md-table-cell :md-label="$I18n('app_id')">{{ item.app_key }}</md-table-cell> -->
              <md-table-cell :md-label="$I18n('app_name')">{{ item.app_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('link_id')">{{ item.link_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('send_desc')">{{ item.send_desc }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop="more_info(item)"
                  class="md-info left-icon"
                  :style="{
                    'width': 'unset',
                    'height': 'unset',
                    'line-height':'16px'
                  }"
                  >{{$I18n("more_info")}}</md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 卡片-表格-翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "true"
      :large = "false"
      :submitBtn= "false"
    >
      <template slot="body">
        <!-- 修改/添加弹窗 -->
        <div class="md-layout">
          <modal-form-item class="md-layout-item md-size-50" :label='"ID"' >
            <md-field >
              <md-input v-model="modalData.id" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("platform_type")' >
            <md-field >
              <md-select v-model="modalData.platform_type" disabled>
                <md-option :value="1">{{$I18n("aliyun")}}</md-option>
                <md-option :value="2">{{$I18n("txyun")}}</md-option>
                <md-option :value="3">{{$I18n("jx")}}</md-option>
                <md-option :value="4">{{"Parsgreen"}}</md-option>
                <md-option :value="5">{{"Kavenegar"}}</md-option>
                <md-option :value="6">{{$I18n("ali_out")}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("platform_name")' >
            <md-field >
              <md-input v-model="modalData.platform_name" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("template_name")' >
            <md-field >
              <md-input v-model="modalData.template_name" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("app_name")' >
            <md-field >
              <md-input v-model="modalData.app_name" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("app_id")' >
            <md-field >
              <md-input v-model="modalData.app_key" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("link_param")' >
            <md-field >
              <md-input v-model="modalData.link_param" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("link_id")' >
            <md-field >
              <md-input v-model="modalData.link_id" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" v-if="modalData.type =='sms'" :label='$I18n("phone")' >
            <md-field >
              <md-input v-model="modalData.link_id" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" v-if="modalData.type =='msg'" label='Token' >
            <md-field >
              <md-input v-model="modalData.link_id" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" v-if="modalData.type =='email'" :label='$I18n("email_address")' >
            <md-field >
              <md-input v-model="modalData.link_id" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("msg_param")' >
            <md-field >
              <md-input v-model="modalData.msg_param" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("send_desc")' >
            <md-field >
              <md-input v-model="modalData.send_desc" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("state")' >
            <md-field >
              <md-input v-model="modalData.state_name" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("update_date")' >
            <md-field >
              <md-input v-model="modalData.update_time" disabled />
            </md-field>
          </modal-form-item>
          <modal-form-item class="md-layout-item md-size-50" :label='$I18n("create_time")' >
            <md-field >
              <md-input v-model="modalData.create_time" disabled />
            </md-field>
          </modal-form-item>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { nDaysAgo, timestampToString1000 } from "@/common/tools.js";
export default {
  props: ["userinfo_sys"],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      // appData : [],
      modalSearchData : {
        file_dev_type : "2",
        time:"",
        state: "0",
      },
      searchForm : {
        app_key : "",
        link_id: "",
        type   : "sms",
        state  : "0",
      },
      searchData : {
        app_key : "",
        link_id: "",
        type   : "sms",
        state  : "0",
      },
      // 表格相关
      icon  : "computer",
      title : this.$I18n("push_record"),
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      openModalType : "upload", // 弹窗类型
      modalTitle : "",  // 弹窗标题
      // 弹窗表单相关
      modalData : {
        state : "1",
        create_time:[nDaysAgo(7)+ " 00:00:00", nDaysAgo(0)+ " 00:00:00"],
        file : "",
        file_url : "",
      },
      // 弹窗表单报错相关
      error: {
        file : false,
      },
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    modalTableData () {
      if (!this.modalTableInitData || this.modalTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalTableInitData]
          .splice((this.import_currentPage-1) * this.import_pageSize, this.import_pageSize)
          .map(item => {
            let type_name = "";
            switch(parseInt(item.type)){
              case 1: 
                type_name = this.$I18n("is_useing");
                break;
              case 2: 
                type_name = this.$I18n("is_outfo_date");
                break;
              default : 
                type_name = this.$I18n("unknow");
                break;
            }
            let state_name = "";
            switch(parseInt(item.state)){
              case 1: 
                state_name = this.$I18n("has_sync_database");
                break;
              case 2: 
                state_name = this.$I18n("has_error_row");
                break;
              case 3: 
                state_name = this.$I18n("has_error_row");
                break;
              default : 
                state_name = this.$I18n("wait_sync_database");
                break;
            }
            return {
              type_name,
              state_name,
              mng_num: item.mng_num ?item.mng_num :0,
              succ_num: item.succ_num ?item.succ_num :0,
              fail_num: item.fail_num ?item.fail_num :0,
              start_time_date : item.start_time ?item.start_time.split(" ")[0] :"",
              end_time_date : item.end_time ?item.end_time.split(" ")[0] :"",
              
              ... item,
            }
          })
      }
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData].map(item => {
          let state_name = "";
          switch(parseInt(item.state)){
            case 1: 
              state_name = this.$I18n("pending");
              break;
            case 2: 
              state_name = this.$I18n("succ_num");
              break;
            case 3: 
              state_name = this.$I18n("fail_num");
              break;
            default : 
              state_name = this.$I18n("unknow");
              break;
          }
          return {
            state_name,
            ... item,
            update_time: timestampToString1000(item.gmt_update),
            create_time: timestampToString1000(item.gmt_create),
          }
        })
      }
    },
  },
  methods: {
    more_info(item){
      this.$refs.modal.open();
      this.modalData = {...item}
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData(){
      this.searchData = {...this.searchForm}
      this.currentPage = 1;
      this.api_getPageData();
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      let page_no = this.currentPage;
      (data => {
        switch (this.searchData.type) {
          case "sms":
            data.push_type = 3;
            return this.$api.getPushRecord(data)
          case "email":
            data.push_type = 2;
            return this.$api.getPushRecord(data)
          case "msg":
            data.push_type = 1;
            return this.$api.getPushRecord(data)
          case "voice":
            data.push_type = 4;
            return this.$api.getPushRecord(data)
        }
      })({
          ...this.searchData,
          sys      : this.userinfo_sys,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          if (page_no !== this.currentPage) {
            return;
          }
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .modal-date.md-date-form-item{
    width: 0;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
    text-align: left;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
